import { gql } from "apollo-boost"

export const News = gql`
{
    allNews {
    name
    link
    logo
  }
}
`